import React from 'react'

import './Footer.scss'

const Footer = () => {

  return (
    <div className='footer'>
      <div>coded <a href="https://github.com/gadaursan/gadaursan.github.io">
        by me
      </a> {'<3'}</div>
      <div>original background picture by davehugs</div>
    </div>
  )
}

export default Footer
